/**
 * TanStack Query hooks for `faster-reporting-via-columnar-backend`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	fasterReportingViaColumnarBackendQueryKeys,
	type CreateFasterReportingViaColumnarBackendBody,
	type ListFasterReportingViaColumnarBackendResponse,
	type FasterReportingViaColumnarBackendRow,
} from "./api";

export function useFasterReportingViaColumnarBackendList(): UseQueryResult<ListFasterReportingViaColumnarBackendResponse, Error> {
	return useQuery({
		queryKey: fasterReportingViaColumnarBackendQueryKeys.list(),
		queryFn: list,
	});
}

export function useFasterReportingViaColumnarBackendCreate(): UseMutationResult<FasterReportingViaColumnarBackendRow, Error, CreateFasterReportingViaColumnarBackendBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fasterReportingViaColumnarBackendQueryKeys.all });
		},
	});
}

export function useFasterReportingViaColumnarBackendDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fasterReportingViaColumnarBackendQueryKeys.all });
		},
	});
}
